export interface TblDecInvProyectoAyud {
    iddecinvproyectoayud: number;
    iddecinvproyecto: number;
    codEstudiante: string;
    descripcion: string;
    termino: string;
    anio: string;
    horas: number;
    actividades: string;
    fechasolicitud: Date;
    ultimocambio: Date;
    idsolicitudayud: number;
    titulo: string;
    estado: string;
    comentario: string;
    financiamientoayudante?: number; // Campo opcional debido al tipo `int?`
    mailresponsable: string;
    iddetallesolicitudayud?: number; // Campo opcional debido al tipo `int?`
  }

  export function VoidTblDecInvProyectoAyud(): TblDecInvProyectoAyud {
    return {
      iddecinvproyectoayud: 0,
      iddecinvproyecto: 0,
      codEstudiante: '',
      descripcion: '',
      termino: '',
      anio: '',
      horas: 0,
      actividades: '',
      fechasolicitud: new Date(0), // Fecha predeterminada (01/01/1970)
      ultimocambio: new Date(0), // Fecha predeterminada (01/01/1970)
      idsolicitudayud: 0,
      titulo: '',
      estado: '',
      comentario: '',
      financiamientoayudante: undefined, // Campo opcional
      mailresponsable: '',
      iddetallesolicitudayud: undefined // Campo opcional
    };
  }